/**
 * SECTION — GLOBAL CARD GRID
 *
 * Adds `.draw` to the section when it scrolls into view, which fires the
 * sleeping-cat animation (draw-on → breathe → zzz). Progressive enhancement:
 * without JS the cat is already fully drawn (stroke-dashoffset 0).
 */
(function () {
  'use strict';

  function init() {
    var sections = document.querySelectorAll('.principles');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('draw'); });
      return;
    }

    sections.forEach(function (section) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('draw');
            io.disconnect();
          }
        });
      }, { threshold: 0.25 });
      io.observe(section);
      // Safety: reveal even if the observer never fires.
      setTimeout(function () { section.classList.add('draw'); }, 2600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
